document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const open = nav.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const selected = selector.options[selector.selectedIndex];
  const form = selector.closest('form');
  const idInput = form && form.querySelector('input[name="id"]');
  if (idInput) idInput.value = selected.value;
  const price = document.querySelector('[data-product-price]');
  if (price && selected.dataset.price) price.textContent = selected.dataset.price;
  const button = form && form.querySelector('[type="submit"]');
  if (button) {
    const available = selected.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
});
